import React, {Component} from 'react';

class Version extends Component {
    render() {
        return (
            <>Version 0.1.6</>
        );
    }
}

export default Version;